import { useEffect, useState } from 'react';
import { configLoader } from '@/lib/config-loader';
import type { ModuleConfig } from '@/lib/types';

export function useModuleConfig(moduleId: string) {
  const [config, setConfig] = useState<ModuleConfig | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    let cancelled = false;

    async function load() {
      try {
        setLoading(true);
        setError(null);
        const moduleConfig = await configLoader.loadModuleConfig(moduleId);
        if (!cancelled) {
          setConfig(moduleConfig);
        }
      } catch (err) {
        if (!cancelled) {
          setError(err instanceof Error ? err : new Error('Failed to load module config'));
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    }

    load();

    return () => {
      cancelled = true;
    };
  }, [moduleId]);

  return { config, loading, error };
}
